export default __webpack_public_path__ + "static/media/homeIcon.27692ab9.svg";